export function LoadingStar() {
  return (
    <svg
      className='animate-bounce-infinite text-yellow m-0 mx-auto mb-14 block h-auto w-8 overflow-visible md:w-10'
      fill='none'
      height='40'
      viewBox='0 0 35 40'
      width='35'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18.5145 39.6245L13.645 35.7869C13.2972 35.438 12.6016 35.2636 12.2538 35.438L6.34085 37.1824C5.12348 37.5312 3.90613 36.3102 4.42786 35.0891L6.68866 29.3327C6.86257 28.8094 6.86259 28.2861 6.51477 27.7628L3.03657 22.7041C2.34093 21.6575 3.03658 20.0876 4.42786 20.262L10.5147 20.6109C11.0364 20.6109 11.5581 20.4364 11.906 19.9131L15.732 15.0289C16.6015 13.9823 18.1667 14.3312 18.5145 15.5522L20.0797 21.4831C20.2536 22.0064 20.6014 22.3552 21.1232 22.5297L26.8622 24.6229C28.0796 25.1462 28.2535 26.7162 27.21 27.4139L21.9927 30.7282C21.471 31.0771 21.2971 31.426 21.2971 31.9493L21.1232 38.0546C21.1232 39.7989 19.558 40.4967 18.5145 39.6245Z'
        fill='currentColor'
      />
      <path
        className='animate-shine-infinite opacity-0'
        d='M3.73349 7.00323C3.03785 6.13105 1.64659 5.95661 0.77705 6.65436C-0.0924914 7.3521 -0.266394 8.7476 0.429239 9.61978L3.90741 14.1551C4.25522 14.6784 4.95084 15.0273 5.47257 15.0273C5.99429 15.0273 6.34211 14.8529 6.68992 14.504C7.55946 13.8063 7.73339 12.4108 7.03776 11.5386L3.73349 7.00323Z'
        fill='currentColor'
      />
      <path
        className='animate-shine-infinite-2 opacity-0'
        d='M19.3882 0.0267139C18.3448 -0.147723 17.1274 0.550024 16.9535 1.59665L15.7361 7.17862C15.5622 8.22524 16.2578 9.4463 17.3013 9.62074C17.4752 9.62074 17.6491 9.62074 17.6491 9.62074C18.6926 9.62074 19.3882 8.92299 19.736 8.05081L20.9534 2.46883C21.3012 1.42221 20.6056 0.375587 19.3882 0.0267139Z'
        fill='currentColor'
      />
      <path
        className='animate-shine-infinite-3 opacity-0'
        d='M34.5149 12.2374C33.8193 11.3652 32.6019 11.0163 31.7324 11.7141L27.0368 14.8539C26.1673 15.5517 25.8194 16.7727 26.5151 17.6449C26.8629 18.1682 27.5585 18.5171 28.2542 18.5171C28.602 18.5171 29.1237 18.3427 29.4715 18.1682L34.1671 15.0284C35.0366 14.5051 35.2106 13.1096 34.5149 12.2374Z'
        fill='currentColor'
      />
    </svg>
  );
}
